import { useParams } from 'react-router-dom'
import { Box, CircularProgress, Typography } from '@mui/material'
import { PowerBIEmbed } from 'powerbi-client-react'
import { models } from 'powerbi-client'
import { useDashboards } from '~/contexts'
import { useDashboardsGetEmbedInfoQuery } from '~/graphql/types'

export const Dashboard: React.FC = () => {
  const { internalId } = useParams<{ internalId: string }>()
  const { dashboards } = useDashboards()

  const dashboard = dashboards.find(d => d.internalId === internalId)

  const { data, loading, error } = useDashboardsGetEmbedInfoQuery({
    variables: { internalId: internalId! },
    skip: !internalId,
    fetchPolicy: 'no-cache',
  })

  const embedInfo = data?.dashboardsGetEmbedInfo

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', m: -3, overflow: 'hidden' }}>
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
          <CircularProgress />
        </Box>
      )}

      {error && !loading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
          <Typography color='error'>Não foi possível carregar o dashboard.</Typography>
        </Box>
      )}

      {embedInfo && !loading && !error && (
        <PowerBIEmbed
          embedConfig={{
            type: 'report',
            tokenType: models.TokenType.Embed,
            accessToken: embedInfo.embedToken,
            embedUrl: embedInfo.embedUrl,
            id: embedInfo.reportId,
            settings: {
              filterPaneEnabled: false,
              navContentPaneEnabled: true,
              panes: {
                pageNavigation: {
                  visible: true,
                  position: models.PageNavigationPosition.Left,
                }
              }
            },
          }}
          cssClassName="powerbi-report-container"
        />
      )}

      <style>{`
        .powerbi-report-container {
          width: 100%;
          height: calc(100vh - 64px);
        }
        .powerbi-report-container iframe {
          width: 100%;
          height: 100%;
          border: none;
          display: block;
        }
      `}</style>
    </Box>
  )
}
